<div class="wysiwyg" [innerHTML]="content.content.text | makeReferencesAbsolute"></div>
